import * as cruPayments from '@cruglobal/cru-payments/dist/cru-payments-cc';
import { allCountries } from 'country-region-data';

import template from './payment.html';
import creditCardTemplate from './paymentMethods/creditCard.html';
import creditCardOfflineTemplate from './paymentMethods/creditCardOffline.html';
import checkAdminTemplate from './paymentMethods/checkAdmin.html';
import checkTemplate from './paymentMethods/check.html';
import transferTemplate from './paymentMethods/transfer.html';
import scholarshipAdminTemplate from './paymentMethods/scholarshipAdmin.html';
import scholarshipTemplate from './paymentMethods/scholarship.html';
import giftCardTemplate from './paymentMethods/giftCard.html';
import payOnSiteTemplate from './paymentMethods/payOnSite.html';
import additionalExpenseTemplate from './paymentMethods/additionalExpense.html';

angular.module('confRegistrationWebApp').directive('ertPayment', function () {
  return {
    templateUrl: template,
    restrict: 'A',
    scope: {
      currentPayment: '=payment',
      currentRegistration: '=registration',
      paymentMethods: '=paymentMethods',
      isAdminPayment: '=adminPayment',
    },
    controller: function (
      $scope,
      $http,
      $rootScope,
      expenseTypesConstants,
      gettextCatalog,
      ProfileCache,
    ) {
      $scope.conference = $scope.$parent.conference;
      $scope.expenseTypesConstants = expenseTypesConstants;
      $scope.currentYear = new Date().getFullYear();
      $scope.creditCardCountry = 'US';
      $scope.countries = allCountries;
      $scope.accountNumberDisabled = false;

      $scope.paymentMethodsViews = {
        CREDIT_CARD: creditCardTemplate,
        OFFLINE_CREDIT_CARD: creditCardOfflineTemplate,
        CHECK: $scope.isAdminPayment ? checkAdminTemplate : checkTemplate,
        TRANSFER: transferTemplate,
        SCHOLARSHIP: $scope.isAdminPayment
          ? scholarshipAdminTemplate
          : scholarshipTemplate,
        FL_GIFT_CARD: giftCardTemplate,
        PAY_ON_SITE: payOnSiteTemplate,
        ADDITIONAL_EXPENSE: additionalExpenseTemplate,
      };

      $scope.searchStaff = function (val) {
        return $http
          .get(
            'registrations/' + $scope.currentRegistration.id + '/staffsearch',
            { params: { name: val } },
          )
          .then(function (response) {
            return response.data;
          });
      };

      $scope.selectStaff = function (item) {
        $scope.currentPayment.scholarship = {
          staffApprovalName: item.firstName + ' ' + item.lastName,
          staffEmail: item.email,
        };
      };

      //payment validation
      $scope.validatePayment = (currentPayment) => {
        if (angular.isUndefined(currentPayment)) {
          return;
        }
        currentPayment = angular.copy(currentPayment);
        if (!currentPayment.creditCard) {
          currentPayment.creditCard = {};
        }
        if (!currentPayment.offlineCreditCard) {
          currentPayment.offlineCreditCard = {};
        }
        if (!currentPayment.transfer) {
          currentPayment.transfer = {};
        }
        if (!currentPayment.scholarship) {
          currentPayment.scholarship = {};
        }
        if (!currentPayment.check) {
          currentPayment.check = {};
        }
        if (!currentPayment.giftCard) {
          currentPayment.giftCard = {};
        }

        //validate SCHOLARSHIP payments as TRANSFER payments when admin
        if (
          currentPayment.paymentType === 'SCHOLARSHIP' &&
          $scope.isAdminPayment
        ) {
          currentPayment.paymentType = 'TRANSFER';
          currentPayment.transfer = currentPayment.scholarship;
        }

        function required(value) {
          return Boolean(value);
        }

        var paymentErrors = [];
        if (angular.isUndefined(currentPayment.paymentType)) {
          paymentErrors.push(
            gettextCatalog.getString('Please select a payment method.'),
          );
        } else {
          switch (currentPayment.paymentType) {
            case 'CREDIT_CARD':
              var validations = {
                nameOnCard: [
                  {
                    validate: required,
                    errorMessage: gettextCatalog.getString(
                      'You must enter the name on the card.',
                    ),
                  },
                ],
                number: [
                  {
                    validate: required,
                    errorMessage: gettextCatalog.getString(
                      'You must enter a card number.',
                    ),
                  },
                  {
                    validate: cruPayments.card.validate.minLength,
                    errorMessage: gettextCatalog.getString(
                      'This card number must contain at least 13 digits.',
                    ),
                  },
                  {
                    validate: cruPayments.card.validate.maxLength,
                    errorMessage: gettextCatalog.getString(
                      'This card number cannot contain more than 16 digits.',
                    ),
                  },
                  {
                    validate: cruPayments.card.validate.knownType,
                    errorMessage: gettextCatalog.getString(
                      'This card type is not recognized.',
                    ),
                  },
                  {
                    validate: cruPayments.card.validate.typeLength,
                    get errorMessage() {
                      var cardNumber = currentPayment.creditCard.number;
                      var cardType = cruPayments.card.info.type(cardNumber);
                      var expectedLength =
                        cruPayments.card.info.expectedLengthForType(
                          cardNumber,
                        ) || [];
                      var expectedDigits = expectedLength.join(
                        gettextCatalog.getString(' or '),
                      );
                      return gettextCatalog.getString(
                        'This is an invalid {{cardType}} number. It should have {{expectedDigits}} digits.',
                        {
                          cardType: cardType,
                          expectedDigits: expectedDigits,
                        },
                      );
                    },
                  },
                  {
                    validate: cruPayments.card.validate.checksum,
                    errorMessage: gettextCatalog.getString(
                      'This card number is invalid. At least one digit was entered incorrectly.',
                    ),
                  },
                ],
                cvvNumber: [
                  {
                    validate: required,
                    errorMessage: gettextCatalog.getString(
                      'You must enter the security code.',
                    ),
                  },
                  {
                    validate: cruPayments.cvv.validate.minLength,
                    errorMessage: gettextCatalog.getString(
                      'The security code must be at least 3 digits.',
                    ),
                  },
                  {
                    validate: cruPayments.cvv.validate.maxLength,
                    errorMessage: gettextCatalog.getString(
                      'The security code cannot be more than 4 digits.',
                    ),
                  },
                  {
                    validate: function (cvv) {
                      var cardNumber = currentPayment.creditCard.number;
                      var cardType = cruPayments.card.info.type(cardNumber);
                      return cruPayments.cvv.validate.cardTypeLength(
                        cvv,
                        cardType,
                      );
                    },
                    errorMessage: gettextCatalog.getString(
                      'The security code has an invalid length.',
                    ),
                  },
                ],
                expirationMonth: [
                  {
                    validate: required,
                    errorMessage: gettextCatalog.getString(
                      'You must choose an expiration month.',
                    ),
                  },
                  {
                    validate: function (expirationMonth) {
                      return cruPayments.expiryDate.validate.month(
                        expirationMonth,
                        currentPayment.creditCard.expirationYear,
                      );
                    },
                    errorMessage: gettextCatalog.getString(
                      'Your credit card is expired or you selected the wrong month or year.',
                    ),
                  },
                ],
                expirationYear: [
                  {
                    validate: required,
                    errorMessage: gettextCatalog.getString(
                      'You must choose an expiration year.',
                    ),
                  },
                  {
                    validate: cruPayments.expiryDate.validate.year,
                    errorMessage: gettextCatalog.getString(
                      'Your credit card is expired or you selected the wrong year.',
                    ),
                  },
                ],
              };

              // Run all of the validations
              _.forEach(validations, function (validators, field) {
                // Validate this field, stopping on the first failed validator
                var failedValidator = _.find(validators, function (validator) {
                  return !validator.validate(currentPayment.creditCard[field]);
                });
                if (failedValidator) {
                  paymentErrors.push(failedValidator.errorMessage);
                }
              });

              //don't require billing address if admin payment
              if (!$scope.isAdminPayment) {
                if (
                  !currentPayment.creditCard.billingAddress ||
                  !currentPayment.creditCard.billingCity ||
                  !currentPayment.creditCard.billingZip
                ) {
                  paymentErrors.push('Please enter your card billing details.');
                }
              }
              break;
            case 'OFFLINE_CREDIT_CARD':
              if (!currentPayment.offlineCreditCard.transactionId) {
                paymentErrors.push('Please enter a transaction ID.');
              }
              break;
            case 'SCHOLARSHIP':
              if (!currentPayment.scholarship.staffEmail) {
                paymentErrors.push(
                  'Please select a staff member to approve your scholarship.',
                );
              }
              break;
            case 'TRANSFER':
              if (!currentPayment.transfer.accountType) {
                paymentErrors.push('Please select an Account Type.');
              }
              switch (currentPayment.transfer.accountType) {
                case 'STAFF':
                  if (!currentPayment.transfer.accountNumber) {
                    paymentErrors.push('Please enter a Staff Account Number.');
                  }
                  break;
                case 'MINISTRY':
                  if (
                    !currentPayment.transfer.businessUnit ||
                    !currentPayment.transfer.operatingUnit ||
                    !currentPayment.transfer.department
                  ) {
                    paymentErrors.push(
                      'Please fill in all ministry transfer fields.',
                    );
                  }
                  break;
                case 'NON_US_STAFF':
                  if (
                    !currentPayment.transfer.businessUnit ||
                    !currentPayment.transfer.operatingUnit ||
                    !currentPayment.transfer.department ||
                    !currentPayment.transfer.accountNumber
                  ) {
                    paymentErrors.push(
                      'Please fill in Operating Unit and Account Number fields.',
                    );
                  }
                  break;
              }
              break;
            case 'CHECK':
              if ($scope.isAdminPayment) {
                if (!currentPayment.status) {
                  paymentErrors.push('Please select a check status.');
                }
                if (
                  !currentPayment.check.checkNumber &&
                  currentPayment.status === 'RECEIVED'
                ) {
                  paymentErrors.push('Please enter a check number.');
                }
              }
              break;
            case 'FL_GIFT_CARD':
              if (!currentPayment.giftCard.giftCardId) {
                paymentErrors.push(
                  gettextCatalog.getString('Please enter a gift card code.'),
                );
              } else if (
                !/^[a-z0-9]+$/i.test(currentPayment.giftCard.giftCardId)
              ) {
                paymentErrors.push(
                  gettextCatalog.getString(
                    'Gift card code must contain only letters and numbers.',
                  ),
                );
              } else if (currentPayment.giftCard.giftCardId.length < 10) {
                paymentErrors.push(
                  gettextCatalog.getString(
                    'Gift card code must be at least 10 characters.',
                  ),
                );
              } else if (currentPayment.giftCard.giftCardId.length > 12) {
                paymentErrors.push(
                  gettextCatalog.getString(
                    'Gift card code must be no more than 12 characters.',
                  ),
                );
              }
              break;
          }
        }
        $scope.currentPayment.errors = paymentErrors;
      };
      $scope.$watch('currentPayment', $scope.validatePayment, true);

      $scope.$watch('creditCardCountry', (newVal, oldVal) => {
        if (oldVal !== newVal) {
          $scope.currentPayment.creditCard.billingState = null;
          $scope.currentPayment.creditCard.billingZip = null;
        }
      });

      function transformEmployeeIdIntoAccountNumber() {
        const employeeId = $rootScope.globalUser().employeeId;
        return employeeId ? employeeId.replace(/\D/g, '').slice(-7) : '';
      }

      function fetchStaffAccountNumber() {
        $scope.accountNumberDisabled = false;

        // staffAccountNumber is fetched asynchronously after login
        // and may not be in the cached profile yet, so refetch to pick it up
        ProfileCache.clearCache();
        ProfileCache.getCache().then(
          function (profile) {
            // TODO: Remove employeeId fallback once HCM goes live
            $scope.currentPayment.transfer.accountNumber =
              profile.staffAccountNumber ||
              transformEmployeeIdIntoAccountNumber() ||
              '';

            $scope.accountNumberDisabled = !!profile.staffAccountNumber;
          },
          function () {
            $scope.currentPayment.transfer.accountNumber = '';
            $scope.accountNumberDisabled = false;
          },
        );
      }

      $scope.accountTypeChanged = () => {
        if (
          $scope.currentPayment.transfer.accountType === 'STAFF' &&
          !$scope.isAdminPayment
        ) {
          fetchStaffAccountNumber();
        } else {
          $scope.currentPayment.transfer.accountNumber = '';
          $scope.accountNumberDisabled = false;
        }
        [
          $scope.currentPayment.transfer.businessUnit,
          $scope.currentPayment.transfer.department,
        ] =
          $scope.currentPayment.transfer.accountType === 'NON_US_STAFF'
            ? ['INTLM', 'GENL']
            : ['', ''];
      };
    },
  };
});
